import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Scissors, ArrowRightLeft, RefreshCw, ClipboardCheck, HeartPulse, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function ServicesSection() {
  const {
    t
  } = useLanguage();
  const services = [{
    icon: Scissors,
    titleEn: 'Sleeve Gastrectomy',
    titleEs: 'Manga gástrica',
    descEn: 'A procedure that removes a portion of the stomach to reduce its size, helping you feel full sooner.',
    descEs: 'Procedimiento que remueve una parte del estómago para reducir su tamaño y ayudar a sentir saciedad antes.'
  }, {
    icon: ArrowRightLeft,
    titleEn: 'Gastric Bypass',
    titleEs: 'Bypass gástrico',
    descEn: 'A surgery that changes how your stomach and small intestine handle the food you eat.',
    descEs: 'Cirugía que cambia la forma en que el estómago y el intestino delgado procesan los alimentos.'
  }, {
    icon: RefreshCw,
    titleEn: 'Revisional Bariatric Surgery',
    titleEs: 'Cirugía bariátrica de revisión',
    descEn: 'Corrective procedures for patients who have had previous weight loss surgery and need further treatment.',
    descEs: 'Procedimientos correctivos para pacientes que ya tuvieron cirugía bariátrica y necesitan tratamiento adicional.'
  }, {
    icon: ClipboardCheck,
    titleEn: 'Pre-Op Evaluation',
    titleEs: 'Evaluación preoperatoria',
    descEn: 'Comprehensive medical assessment to ensure you are a safe candidate for surgery.',
    descEs: 'Evaluación médica integral para asegurar que eres un candidato seguro para la cirugía.'
  }, {
    icon: HeartPulse,
    titleEn: 'Post-Op Follow-Up',
    titleEs: 'Seguimiento postoperatorio',
    descEn: 'Ongoing medical support and monitoring to help maintain your health after surgery.',
    descEs: 'Apoyo médico continuo y monitoreo para ayudar a mantener tu salud después de la cirugía.'
  }];
  return <section className="py-16 md:py-24 bg-slate-50" id="services" data-id="element-191">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-192">
        <div className="text-center mb-16" data-id="element-193">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-194">
            {t('Our Services', 'Nuestros servicios')}
          </h2>
          <div className="h-1 w-20 bg-teal-500 mx-auto rounded-full" data-id="element-195"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-196">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-xl p-8 shadow-sm hover:shadow-md transition-shadow border border-slate-100 group" data-id="element-197">
              <div className="bg-teal-50 w-14 h-14 rounded-lg flex items-center justify-center mb-6 group-hover:bg-teal-100 transition-colors" data-id="element-198">
                <service.icon className="w-7 h-7 text-teal-600" data-id="element-199" />
              </div>

              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-200">
                {t(service.titleEn, service.titleEs)}
              </h3>

              <p className="text-slate-600 mb-6 leading-relaxed" data-id="element-201">
                {t(service.descEn, service.descEs)}
              </p>

              <a href="#contact" className="inline-flex items-center text-teal-600 font-semibold hover:text-teal-700 transition-colors" data-id="element-202">
                {t('Learn more', 'Ver más')}
                <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-203" />
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}